import { cn } from "@/lib/utils";
import { Button } from "@/styles/ui/button";

export const TabButton = ({
  isActive,
  onClick,
  className,
  disabled = false,
  children,
}: {
  isActive: boolean;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  children: React.ReactNode;
}) => {
  return (
    <Button
      variant="ghost"
      className={cn(
        "transition-colors duration-100 hover:bg-accent outline-none",
        {
          "flex h-7 py-2 px-3 justify-center items-center gap-2 rounded-md bg-[#F5F5F5] shadow-xs":
            isActive,
          "flex h-7 py-2 px-3 justify-center items-center gap-2 rounded-md":
            !isActive,
        },
        className,
      )}
      onClick={onClick}
      disabled={disabled}
    >
      <span
        className={cn("label-1-normal-medium", {
          "text-[#171717]": isActive,
          "text-[#737373]": !isActive,
        })}
      >
        {children}
      </span>
    </Button>
  );
};
